export enum FRIEND_STATUS {
    NOT_CONNECT,
    CONNECTED,
    HAS_REQUESTED,
    PENDING,
}